import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from 'src/app/shared-module/seguridad/services/auth.service';
import {PlantillaService} from '../service-plantilla/plantilla.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  datosUsuario: { apellido: string, email: string, login: string, login2: string, nombre: string };
  nombreUsuario: string;
  isLoggedIn$: Observable<boolean>;
  constructor(
    public _plantilla: PlantillaService,
    private authService: AuthService,
  ) {
  }

  ngOnInit() {
    this._plantilla.variable = '25px';
    if (localStorage.getItem('accessToken') !== '' && localStorage.getItem('accessToken') !== null && localStorage.getItem('userName') !== '') {
      this.isLoggedIn$ = this.authService.isLoggedIn;
      if (localStorage.getItem('mostrarMenu') === 'true') {
        this.datosUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
        this.nombreUsuario = `${this.datosUsuario.nombre} ${this.datosUsuario.apellido}`;
      }
      //console.log(new Date(Date.parse(localStorage.getItem('timeLogin'))));
      //console.log(new Date(new Date().getTime() - (12*3600*1000)) );
      const toc = JSON.parse(atob(localStorage.getItem('accessToken').split('.')[1]));
      //console.log(toc);
      //console.log(new Date(toc.exp * 1000));
      if(new Date(new Date().getTime() ) > new Date(toc.exp * 1000)){
        this.onLogout();
      }
    }
  }

  toggleNavbar() {
    this._plantilla.navbarOpen = !this._plantilla.navbarOpen;
  }

  openNav() {
    this._plantilla.variable = '25px';
    this._plantilla.navbarOpen = true;
  }

  onLogout() {
    this.isLoggedIn$ = this.authService.isLoggedIn;
    this.authService.logout();
  }

}
